import { Backdrop, CircularProgress } from '@mui/material';

const Loader = ({ open, setOpen }) => {

  return (<Backdrop sx={{ color: '#ef233c', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} onClick={(e) => setOpen(false)}>
    <CircularProgress color="inherit" size={50} />
  </Backdrop>);
}

export default Loader;